import { useSelector } from "react-redux";
import { RootState } from "@/App/reducers";

export function usePermissions(): Array<string> {
  const { actions } = useSelector((state: RootState) => state.userPermissionsGet);
  return actions;
}
